// Clean up print_format leakage between reports in Frappe
frappe.provide('tawseel_app');

function clearGlobalPrintFormat() {
	if (window.locals && locals[':Print Settings'] && locals[':Print Settings']['Print Settings']) {
		delete locals[':Print Settings']['Print Settings'].print_format;
	}
}

// Restore original frappe.ui.get_print_settings if previously modified
if (window.frappe && frappe.ui && frappe.ui._orig_get_print_settings) {
	frappe.ui.get_print_settings = frappe.ui._orig_get_print_settings;
	delete frappe.ui._orig_get_print_settings;
}

// Remove custom inner button if it exists
function removeCustomStatementBtn() {
	if (window.frappe && frappe.query_report && frappe.query_report._custom_statement_btn) {
		try {
			frappe.query_report._custom_statement_btn.remove();
		} catch (e) { }
		delete frappe.query_report._custom_statement_btn;
	}
}

// Clear leaked print format on route changes and page changes
$(document).on('app_ready', function () {
	clearGlobalPrintFormat();
	// removeCustomStatementBtn();
	if (frappe.router) {
		frappe.router.on('change', function () {
			clearGlobalPrintFormat();
			// removeCustomStatementBtn();
		});
	}
});

$(document).on('page-change', function () {
	clearGlobalPrintFormat();
	// removeCustomStatementBtn();
});

// Also initialize immediately
clearGlobalPrintFormat();
// removeCustomStatementBtn();
if (window.frappe && frappe.router) {
	frappe.router.on('change', function () {
		clearGlobalPrintFormat();
		// removeCustomStatementBtn();
	});
}
